import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getBase64FromUrl } from "./getBase64FromUrl";

export const exportToPDF = async (
  title: string,
  headers: any[],
  tableData: any[]
) => {
  // Convert logo to Base64
  const logoBase64 = await getBase64FromUrl("/logo.png");

  // PDF setup
  const doc = new jsPDF("landscape", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 10;
  const headerHeight = 20;
  const footerHeight = 15;

  autoTable(doc, {
    head: [headers],
    body: tableData,
    margin: { top: headerHeight + 15, left: 2 }, // space for header/title
    styles: { fontSize: 9, cellPadding: 2, overflow: "linebreak" },
    tableWidth: pageWidth - 0.5 * margin,

    // Header & Footer on each page
    didDrawPage: (data) => {
      const leftMargin = 2;

      // ===== HEADER =====
      doc.setFontSize(12);
      doc.text("Medical Legal Portal", leftMargin, 14);

      // Logo on right
      doc.addImage(logoBase64, "PNG", pageWidth - margin - 28, 5, 34, 12);

      // Title (repeat on each page)
      doc.setFontSize(14);
      doc.text(title, leftMargin, 26);

      // ===== FOOTER =====
      const footerY = pageHeight - 10;
      const now = new Date();
      const formattedDate = now.toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      const storedFirstname = localStorage.getItem("firstname") || "";
      const storedLastname = localStorage.getItem("lastname") || "";

      const generatedByText = `Generated By & On - ${storedFirstname} ${storedLastname} ${formattedDate}`;
      const totalPages = doc.getNumberOfPages();
      const pageNumberText = `Page No. ${data.pageNumber} of ${totalPages}`;

      // footer line
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.1);
      doc.line(1, footerY - 5, pageWidth - 1, footerY - 5);

      // footer text
      doc.setFontSize(8);
      doc.text(generatedByText, 1, footerY);
      doc.text(
        pageNumberText,
        pageWidth - 1 - doc.getTextWidth(pageNumberText),
        footerY
      );
    },
  });

  // Save file
  doc.save(`${title}.pdf`);
};
